import AmexBanner from './AmexBanner';

export default AmexBanner;
